module.exports = __webpack_public_path__ + "img/PS Gaming.d6b4e2b1.png";